import { useNavigate } from "react-router-dom";
import { jwtDecode } from 'jwt-decode';

// Check if token is expired
const isTokenExpired = (token) => {
  if (!token) return true;
  const decodedToken = jwtDecode(token);
  const currentTime = Date.now() / 1000; // Current time in seconds
  return decodedToken.exp < currentTime; // Token is expired if exp < current time
};

const AuthGuard = ({ children }) => {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("jwtToken");

  // If token is expired, redirect to login
  if (isTokenExpired(token)) {
    sessionStorage.clear(); // Clear the session
    navigate("/session/signin"); // Redirect to login
    return null; // Don't render the protected route
  }

  return children; // If token is valid, render children (protected route)
};

export default AuthGuard;
